import {makeAutoObservable} from "mobx";

class FreeBetsStore {

    freeBet = null;

    constructor() {
        makeAutoObservable(this);
    }

    setFreeBets(data) {
        this.freeBet = data;
    }

    getFreeBetLeftCount() {
        return this.freeBet ? this.freeBet.quantity - this.freeBet.usedQuantity : null;
    }

    minusFreeBet() {
        this.freeBet.usedQuantity += 1;
    }
}

export const freeBetsStore = new FreeBetsStore();
